import { formFileUrlFromFileArray } from '../../utils/fileHelper';
import { sortObjectArray } from '../../utils/arrayHelpers';
import { restaurantProviders } from '../../enums/restaurantProviders';
import { mapApiToDataPaymentOption } from './restaurant';
import { defaultColors } from '../../configs';

export const mapDeliverySettings = ({ settings }) => {
  if (!settings) {
    return null;
  }

  const mappedCategories = settings.categories
    ? settings.categories.map((category) => {
        return {
          id: category.id,
          imageUrl: formFileUrlFromFileArray(category.image),
          name: category.name,
          order: category.order || 9999,
          restaurants: category.restaurants,
        };
      })
    : null;

  if (mappedCategories) {
    sortObjectArray(mappedCategories, 'order', 1, true);
  }

  return {
    deliveryId: settings._id,
    title: settings.title,
    description: settings.description,
    bannerUrl: formFileUrlFromFileArray(settings.banner),
    logoUrl: formFileUrlFromFileArray(settings.logo),
    categories: mappedCategories,
    colors: formatDeliverySettingsColors(settings),
  };
};

const formatDeliverySettingsColors = (settings) => {
  const settingsColors = settings.colors && settings.colors.length > 0 ? settings.colors[0] : null;

  const formed = {};

  if (settingsColors) {
    formed.primary = settingsColors.primary || defaultColors.primary;
    formed.hasCustomPrimary = !!settingsColors.primary;
  }

  return formed;
};

export const mapDeliveryRestaurants = ({ restaurants }) => {
  if (!restaurants || restaurants.length === 0) {
    return null;
  }

  const addWorkTime = (arr, day, from, until) => {
    if (from >= 0 && until >= 0 && from <= 1440 && until <= 1440) {
      arr.push({ day, from, until });
    }
  };

  const mappedRestaurants = restaurants
    .filter((restaurant) => !!restaurant.table && !!restaurant.data)
    .map((restaurant) => {
      const workTimes = [];

      const schedule =
        restaurant.schedule && restaurant.schedule.length > 0 ? restaurant.schedule[0] : {};

      addWorkTime(workTimes, 1, schedule.mon_from, schedule.mon_to);
      addWorkTime(workTimes, 2, schedule.tue_from, schedule.tue_to);
      addWorkTime(workTimes, 3, schedule.wed_from, schedule.wed_to);
      addWorkTime(workTimes, 4, schedule.thu_from, schedule.thu_to);
      addWorkTime(workTimes, 5, schedule.fri_from, schedule.fri_to);
      addWorkTime(workTimes, 6, schedule.sat_from, schedule.sat_to);
      addWorkTime(workTimes, 7, schedule.sun_from, schedule.sun_to);

      return {
        id: restaurant.restaurant, // restaurant id
        deliveryId: restaurant._id, // delivery restaurant id
        title: restaurant.title,
        slug: restaurant.slug,
        description: restaurant.description,
        specialTag: restaurant.special_tag,
        order: restaurant.order,
        phone: restaurant.phone,
        email: restaurant.email,
        hasDelivery: restaurant.has_delivery,
        hasTakeaway: restaurant.has_takeaway,
        imageUrl: formFileUrlFromFileArray(restaurant.image),
        bannerUrl: formFileUrlFromFileArray(restaurant.banner),
        workTimes,
        takeawayNowMin: restaurant.takeaway_now_min,
        takeawayNowMax: restaurant.takeaway_now_max,
        deliveryNowMin: restaurant.delivery_now_min,
        deliveryNowMax: restaurant.delivery_now_max,
        deliveryPrice: restaurant.delivery_price || 0,
        minDeliveryOrder: restaurant.min_delivery_order || 0,
        minTakeawayOrder: restaurant.min_takeaway_order || 0,
        table: {
          id: restaurant.table._id,
          qr: restaurant.table.qr,
          section: restaurant.table.area_name,
        },
        data: {
          id: restaurant.data._id,
          companyId: restaurant.data.company,
          name: restaurant.data.name,
          phone: restaurant.data.phone,
          logo: restaurant.data.logo,
          country: restaurant.data.country,
          city: restaurant.data.city,
          street: restaurant.data.street,
          postalCode: restaurant.data.postal_code,
          timeZone: restaurant.data.zone,
          integrationId: restaurant.data.integration_id,
          provider: restaurant.data.rkeeper_code
            ? restaurantProviders.RKeeper
            : restaurantProviders.Iiko,
          type: restaurant.data.type,
          restrictionsAge: restaurant.data.restrictions_age,
        },
        paymentOption: mapApiToDataPaymentOption({ options: restaurant.payment_options }),
      };
    });

  if (mappedRestaurants) {
    sortObjectArray(mappedRestaurants, 'order', 1, true);
  }

  return mappedRestaurants;
};
